import { animate, useReducedMotion } from "motion/react";
import { useEffect, useRef, useState } from "react";

import { useValueFormatter } from "@/utils/useValueFormatter";

const COUNT_TRANSITION = { duration: 0.4, ease: [0.22, 1, 0.36, 1] } as const;

export function AnimatedCount({ value }: { value: number }) {
  const { format } = useValueFormatter();
  const prefersReducedMotion = useReducedMotion();
  const [displayed, setDisplayed] = useState(value);
  const current = useRef(value);

  useEffect(() => {
    if (prefersReducedMotion) {
      current.current = value;
      setDisplayed(value);
      return;
    }
    const controls = animate(current.current, value, {
      ...COUNT_TRANSITION,
      onUpdate: (latest) => {
        current.current = latest;
        setDisplayed(Math.round(latest));
      },
    });
    return () => controls.stop();
  }, [value, prefersReducedMotion]);

  return <span className="tabular-nums">{format(displayed, "whole")}</span>;
}
